var _defs, _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    zoomAndPan: "magnify",
    viewBox: "0 0 60 37.5",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ea0e9cf46c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.652344 1.652344 L 53.28125 1.652344 L 53.28125 35.695312 L 6.652344 35.695312 Z M 6.652344 1.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "554b1db7ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 1.652344 L 41 1.652344 L 41 35.695312 L 19 35.695312 Z M 19 1.652344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea0e9cf46c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M 11.84375 1.652344 C 8.984375 1.652344 6.664062 3.996094 6.664062 6.890625 L 6.664062 30.460938 C 6.664062 33.351562 8.984375 35.695312 11.84375 35.695312 L 19.609375 35.695312 L 19.609375 1.652344 Z M 48.089844 1.652344 L 40.324219 1.652344 L 40.324219 35.695312 L 48.089844 35.695312 C 50.949219 35.695312 53.269531 33.351562 53.269531 30.460938 L 53.269531 6.890625 C 53.269531 3.996094 50.949219 1.652344 48.089844 1.652344 Z M 48.089844 1.652344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#554b1db7ed)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eeeeee",
    d: "M 19.609375 1.652344 L 40.324219 1.652344 L 40.324219 35.695312 L 19.609375 35.695312 Z M 19.609375 1.652344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M 30.761719 24.058594 C 32.3125 24.242188 33.703125 24.40625 35.253906 24.585938 L 34.859375 23.273438 C 34.796875 23.042969 34.886719 22.789062 35.066406 22.648438 L 39.570312 18.9375 L 38.636719 18.496094 C 38.226562 18.347656 38.339844 18.113281 38.488281 17.550781 L 39.175781 15.015625 L 36.558594 15.574219 C 36.304688 15.613281 36.132812 15.449219 36.09375 15.292969 L 35.757812 14.097656 L 33.6875 16.449219 C 33.394531 16.824219 32.800781 16.824219 32.984375 15.957031 L 33.867188 11.195312 L 32.683594 11.820312 C 32.347656 12.007812 32.015625 12.039062 31.832031 11.703125 L 30.195312 8.605469 L 30.195312 8.679688 L 30.195312 8.605469 L 28.554688 11.703125 C 28.371094 12.039062 28.035156 12.007812 27.703125 11.820312 L 26.519531 11.195312 L 27.402344 15.957031 C 27.589844 16.824219 26.992188 16.824219 26.699219 16.449219 L 24.628906 14.101562 L 24.292969 15.292969 C 24.253906 15.449219 24.082031 15.613281 23.828125 15.574219 L 21.210938 15.015625 L 21.898438 17.550781 C 22.046875 18.113281 22.160156 18.347656 21.75 18.496094 L 20.816406 18.941406 L 25.320312 22.652344 C 25.5 22.789062 25.589844 23.042969 25.527344 23.273438 L 25.128906 24.585938 L 29.621094 24.0625 C 29.761719 24.0625 29.851562 24.136719 29.847656 24.296875 L 29.574219 29.148438 L 30.808594 29.148438 L 30.535156 24.296875 C 30.535156 24.136719 30.625 24.058594 30.761719 24.058594 Z M 30.761719 24.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.46ebd104afe087b9f6798ba4dc7fda93.svg";
export { ForwardRef as ReactComponent };